<style lang="scss" scoped>
.scroll {
  height: 90%;
  overflow: auto;
}
.stories {
  background-color: #fff;
  height: 100%;
  width: 100%;
}
.wrapper {
  margin: auto;
  margin-top: 50px;
  width: 90%;
}
.logout {
  cursor: pointer;
}
.box {
  margin-top: 50px;
  width: 100%;
}
form {
  overflow: scroll;
  // max-height: 800px;
}

.search {
  margin: 10px 0;
}
</style>
<template>
  <div class="stories has-navbar-fixed-top">
    <div class="wrapper height-100">
      <Header />
      <div class="frow height-100 scroll">
        <div class="box height-100">
          <div class="frow gutters height-100">
            <div class="col-md-1-3 height-100">
              <nav class="panel height-100">
                <p class="panel-heading">
                  Stories
                </p>
                <div class="frow mt-5 mb-5">
                  <button @click="showNewStoryModal = true">
                    Add New Story
                  </button>
                  <input
                    v-model="search"
                    class="input search"
                    placeholder="Search Stories..."
                  >
                  <div class="field">
                    <label
                      class="checkbox reset frow mt-20 ml-10"
                    >
                      <div class="frow justify-start">
                        <input
                          v-model="missingLink"
                          type="checkbox"
                        >
                        has no link
                      </div>
                    </label>
                  </div>
                </div>
                <div class="scroll">
                  <DecadeAccordian
                    :active-item="activeStory"
                    :items="filteredStories"
                    @setActiveItem="changeStory"
                  />
                </div>
              </nav>
              <button @click="showNewStoryModal = true">
                Add New Story
              </button>
            </div>
            <div class="col-md-2-3">
              <div v-if="activeStory">
                <h1>{{ activeStory.title }}</h1>
                <div class="tabs">
                  <ul>
                    <li
                      :class="{'is-active': activeTab == 'storyInfo'}"
                      @click="activeTab = 'storyInfo'"
                    >
                      <a>
                        Story Info
                      </a>
                    </li>
                    <!-- <li
                      :class="{'is-active': activeTab == 'steps'}"
                      @click="activeTab = 'steps'"
                    >
                      <a>
                        Steps
                      </a>
                    </li> -->
                    <li
                      :class="{'is-active': activeTab == 'deleteStory'}"
                      @click="activeTab = 'deleteStory'"
                    >
                      <a>
                        Delete Story
                      </a>
                    </li>
                  </ul>
                </div>
                <StoryForm
                  v-if="activeTab == 'storyInfo' && !showNewStoryModal"
                  :story="activeStory"
                />
                <!-- <StorySteps
                  v-if="activeTab == 'steps'"
                  :steps.sync="activeStory.steps"
                  :story="activeStory"
                /> -->
                <DeleteStory
                  v-if="activeTab == 'deleteStory'"
                  :story="activeStory"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewStoryModal
      v-if="showNewStoryModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import StoryForm from '@/components/Stories/StoryForm.vue';
import DeleteStory from '@/components/Stories/DeleteStory.vue';
import NewStoryModal from '@/components/Stories/NewStoryModal.vue';
import Header from '@/components/Header.vue';
import DecadeAccordian from '@/components/DecadeAccordian';
import store from '@/store';

export default {
  name: 'Stories',
  components: {
    StoryForm,
    DeleteStory,
    NewStoryModal,
    Header,
    DecadeAccordian,
  },
  data() {
    return {
      activeTab: 'storyInfo',
      stories: null,
      showNewStoryModal: false,
      search: null,
      missingLink: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
      activeStory: (state) => state.activeStory,
    }),
    API() {
      return this.$API;
    },
    filteredStories() {
      if (this.search || this.missingLink) {
        let stories = this.stories;
        if (this.missingLink) {
          stories = this.stories.filter((story) => {
            console.log(`Checking link ${story.link}`);
            return !story.link;
          }); 
        }
        if (this.search) {
          stories = stories.filter((story) => {
            return story.title.toLowerCase().includes(this.search.toLowerCase());
          });
        }
        return stories;
      }
      return this.stories;
    },
  },
  created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/admin/login');
    } else {
      this.getStories();
      this.refreshActiveStory();
    }
  },
  methods: {
    ...mapActions([
      'setActiveStory',
    ]),
    getStories() {
      this.axios.get(`${this.$API}/stories-stripped?_sort=date:ASC`).then((response) => {
        this.stories = response.data;
        if (this.activeStory == null) {
          this.setActiveStory(this.stories[0]);
        }
      });
    },
    refreshActiveStory() {
      this.activeStory = this.stories.find((s) => s.id == this.activeStory.id);
    },
    closeModal() {
      this.getStories();
      this.showNewStoryModal = false;
    },
    changeStory(story) {
      this.setActiveStory(story); 
      this.activeTab = 'storyInfo';
    },
  },
};
</script>
